<template>
    <div class="one-order">
        <a href="#" class="order-link js-order-link">
            <span class="order-num">
                <span class="label">{{order.MESSAGES.ORDER_ID}}</span>
               {{order.ID}}
            </span>
            <span class="order-status">
                <span class="label">{{order.MESSAGES.STATUS}}</span>
                            {{order.ORDER_STATUS}}
            </span>
            <span class="order-date">
                <span class="label">{{order.MESSAGES.DATE}}</span>
                            {{order.DATE}}
            </span>
            <span class="order-total">
                <span
                        class="label">{{order.MESSAGES.PROD}}</span>
                <b>{{order.PRICE}}</b>
            </span>
        </a>
        <div class="order-info">
            <div class="order-info-descr">
                <table class="order-table">
                    <tbody>
                    <tr>
                        <td>{{order.MESSAGES.DELIVERY}}</td>
                        <td>{{order.DELIVERY_NAME}}</td>
                    </tr>
                    <tr>
                        <td>{{order.MESSAGES.CITY}}</td>
                        <td>{{order.USER_CITY}}</td>
                    </tr>
                    <tr>
                        <td>{{order.MESSAGES.ADDRESS}}</td>
                        <td>{{order.USER_ADDRESS}}</td>
                    </tr>
                    <tr>
                        <td>{{order.MESSAGES.USER}}</td>
                        <td>{{order.USER_NAME}}</td>
                    </tr>
                    <tr>
                        <td>{{order.MESSAGES.PHONE}}</td>
                        <td>{{order.USER_PHONE}}</td>
                    </tr>
                    <tr>
                        <td>{{order.MESSAGES.DELIVERY_COST}}</td>
                        <td>{{order.DELIVERY_PRICE}}</td>
                    </tr>
                    </tbody>
                </table>
                <div class="payment-status">
                    <div>
                        <div class="label">{{order.MESSAGES.PAY}}</div>
                        {{order.PS_NAME}}
                    </div>
                    <div>
                        <div class="label">{{order.MESSAGES.PAY_STATUS}}</div>
                        <div class="text-success">{{order.PS_STATUS}}</div>
                    </div>
                </div>
            </div>

            <table class="ordered-products">
                <tbody>
                <tr v-for="basket in order.BASKET">
                    <td>
                        <a :href=basket.DETAIL_PAGE_URL class="img-cont">
                            <img :src=basket.PICTURE alt="">
                        </a>
                    </td>
                    <td>
                        <a :href=basket.DETAIL_PAGE_URL
                           class="prod-name">{{basket.NAME}}</a>
                        <div class="vendor-code">{{basket.ARTICULE}} </div>
                    </td>
                    <td>
                        {{basket.PRICE}}
                    </td>
                    <td>
                        {{basket.QUANTITY}}
                    </td>
                    <td>
                        {{basket.SUM}}
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="products-wrap">
                <div class="one-order-prod">

                </div>
            </div>

            <div class="bottom-order">
                <a href="#" class="js-hide-detail">
                    {{order.MESSAGES.DETAIL}}
                </a>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';


    export default {
        name: "order",

        props: [
            'order'
        ],

        data() {
            return {
            }
        },

        computed: {

        },

        mounted() {
        },


        methods: {

        }
    }


</script>
